import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'
import createClassNames from 'classnames'

import { withStyles } from '@material-ui/core/styles'
import MuiButton from '@material-ui/core/Button'

import CsgFlex from 'components/atoms/Flex'

import theme from 'app/theme'
import { colorPropType } from 'app/utils'

const styles = theme => ({
  link: {
    fontSize: 14,
    textTransform: 'none',
    backgroundColor: 'transparent'
  },
  radius: {
    borderRadius: 20
  },
  listButton: {
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2)
  }
})

const ButtonStyled = withStyles(styles)(({ link, radius, btnColor, classes, listButton, bgColor, ...props }) => {
  const classNames = createClassNames({
    [classes.link]: !!link,
    [classes.radius]: !!radius,
    [classes.listButton]: !!listButton
  })

  const styleBtnColor = btnColor
    ? { color: theme.palette[btnColor].main, borderColor: theme.palette[btnColor].main }
    : {}
  const styleBackgroundColor = bgColor ? { backgroundColor: theme.palette[bgColor].main } : {}
  return (
    <MuiButton
      data-testid="button"
      className={classNames}
      style={{ ...styleBtnColor, ...styleBackgroundColor }}
      {...props}
    />
  )
})

const LeftIcon = styled.div`
  margin-right: ${theme.spacing(2)}px;
  display: flex;
`

const RightIcon = styled.div`
  margin-left: ${theme.spacing(2)}px;
  display: flex;
`

const Button = ({ icon, children, iconPlacement = 'left', ...props }) => (
  <ButtonStyled {...props}>
    <CsgFlex alignItems="center" data-testid="button-flex">
      {icon && iconPlacement === 'left' && (
        <LeftIcon data-testid="button-icon" style={{ marginRight: 4 }}>
          {icon}
        </LeftIcon>
      )}
      {children}
      {icon && iconPlacement === 'right' && (
        <RightIcon data-testid="button-icon" style={{ marginLeft: 4 }}>
          {icon}
        </RightIcon>
      )}
    </CsgFlex>
  </ButtonStyled>
)

Button.propTypes = {
  ...MuiButton.propTypes,
  link: PropTypes.bool,
  radius: PropTypes.bool,
  color: PropTypes.string,
  listButton: PropTypes.bool,
  btnColor: colorPropType,
  bgColor: colorPropType
}

export default Button
